import React from "react";
import sanitizeHtml from "sanitize-html";
import Modal from "scripts/share/components/Modal";
import Button from "ui-components/Button";
import doFetch from "scripts/data_utils/doFetch";
import { urlNaturalPersonFormPage } from "scripts/constants/urls";
import { ModalContainer, Title, Description, ActionContainer, MessageIP, LinkForm } from "./styles";

const ShowNewPublicOfferModal = props => {
  const {
    enable = true,
    submitCallback
  } = props;
  const options = {
    closeButton: false,
    animated: true,
    centered: true,
    isMobileViewportFit: true,
    overlayClose: false,
    overscrollBehaviorBlock: true
  };
  const [isLoading, setIsloading] = React.useState(true);
  const [modalRoot, setModalRoot] = React.useState(null);
  const [offerSanitizedText, setOfferSanitizedText] = React.useState("<p>Loading ...</p>");
  React.useEffect(() => {
    const fetchOfferData = async () => {
      var _responseData$result$, _responseData$result;

      const response = await fetch("/api/pages/pages/offer/");
      const responseData = await response.json();
      const offerText = (_responseData$result$ = responseData === null || responseData === void 0 ? void 0 : (_responseData$result = responseData.result) === null || _responseData$result === void 0 ? void 0 : _responseData$result.text) !== null && _responseData$result$ !== void 0 ? _responseData$result$ : "Не удалось загрузить текст соглашения";
      setOfferSanitizedText(getOfferSanitizeText(offerText));
      setIsloading(false);
    };

    const _modalRoot = document.querySelector("div#offer-modal");

    fetchOfferData();
    setModalRoot(_modalRoot);
    /* HACK: a solution that forces you to use units relative to the viewport for ios safari */

    /* 1) First we get the viewport height and we multiple it by 1% to get a value for a vh unit */

    const vh = window.innerHeight * 0.01;
    /* Then we set the value in the --vh custom property to the root of the document */

    document.documentElement.style.setProperty("--vh", `${vh}px`);
    document.body.classList.add("offer-modal");
    return () => {
      document.body.classList.remove("offer-modal");
    };
  }, []);

  const acceptNewOffer = () => {
    doFetch(`/api/account/offer-agreement/`, {
      method: "POST"
    }).then(async responseData => {
      if (responseData.errors.length === 0) {
        submitCallback();
      }
    });
  };

  if (!enable || isLoading) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Modal, {
    isModalVisible: true,
    options: options,
    rootNode: modalRoot
  }, /*#__PURE__*/React.createElement(ModalContainer, {
    className: "offer-modal-fix"
  }, /*#__PURE__*/React.createElement(Title, null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u043F\u0440\u0430\u0432\u0438\u043B \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u044B"), /*#__PURE__*/React.createElement(Description, {
    dangerouslySetInnerHTML: {
      __html: offerSanitizedText
    }
  }), /*#__PURE__*/React.createElement(MessageIP, null, "\u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u043D\u0435 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D \u0441\u0442\u0430\u0442\u0443\u0441 \u0441\u0430\u043C\u043E\u0437\u0430\u043D\u044F\u0442\u043E\u0433\u043E \u0438\u043B\u0438 \u0418\u041F,", " ", /*#__PURE__*/React.createElement(LinkForm, {
    href: urlNaturalPersonFormPage
  }, "\u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u0443"), " ."), /*#__PURE__*/React.createElement(ActionContainer, null, /*#__PURE__*/React.createElement(Button, {
    id: "action-accept-new-offer",
    buttonType: "button",
    variation: "success",
    title: "\u041F\u0420\u0418\u041D\u042F\u0422\u042C",
    stretched: false,
    dataAttrs: {
      "cy-id": "action-accept-new-offer"
    },
    onClick: acceptNewOffer
  }))));
};

const getOfferSanitizeText = dirtyText => sanitizeHtml(dirtyText, {
  allowedTags: ["h3", "h4", "h5", "h6", "blockquote", "p", "a", "ul", "ol", "li", "b", "i", "strong", "em", "hr", "br", "div", "tr", "th", "td", "pre"],
  allowedAttributes: {
    "*": ["data-*"],
    a: ["href", "link", "target", "data-*"],
    img: ["src"]
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr"],
  nonTextTags: ["style", "script", "textarea", "option", "noscript"],

  exclusiveFilter(frame) {
    return !frame.text.trim();
  }

});

export { ShowNewPublicOfferModal as default };